import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    CButton,
    CRow,
    CCol,
    CCard,
    CCardBody,
    CHeader, CContainer, CHeaderNav, CNavItem, CNavLink,
    CTable,
    CTableBody,
    CTableDataCell,
    CTableHead,
    CTableHeaderCell,
    CTableRow,
    CModal,
    CModalHeader,
    CModalTitle,
    CModalBody,
    CModalFooter,
    CPagination,
    CPaginationItem
} from '@coreui/react';
import { FaRedoAlt, FaFilter, FaSearch, FaFileInvoiceDollar } from "react-icons/fa";
import { BsChevronRight } from 'react-icons/bs';
import '../../../assets/css/mainstyle.css';
import '../../../assets/css/ClientSidebar.css';

import Adminprofil from '../../../assets/images/adminprofil.png';

import api from '../../../service/caller';
import { toast } from 'react-toastify';

const PaymentList = () => {
    const [UserData, setUserData] = useState([]);
    const navigate = useNavigate();
    const [visible, setVisible] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [loading, setLoading] = useState(false);
    const itemsPerPage = 10; // Nombre d'éléments par page
    const [departments, setDepartments] = useState([]);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [filteredBillings, setFilteredBillings] = useState([]);
    const [displayedBillings, setDisplayedBillings] = useState([]);
    const [billings, setBillings] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedBilling, setSelectedBilling] = useState({
        paymentuniqueId: '',
        operationtype: '',
        operationcode: '',
        department: '',
        amount: 0,
        currency: '',
        paymentstatus: false,
    });
    const [selectedServiceType, setSelectedServiceType] = useState('');

    const handleShowModal = (billing) => {
        setSelectedBilling(billing);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedBilling({
            paymentuniqueId: '',
            operationtype: '',
            operationcode: '',
            department: '',
            amount: 0,
            currency: '',
            paymentstatus: false,
        });
    };

    useEffect(() => {
        const fetchLoggedUserData = async () => {
            try {
                const response = await api.get('api/usersprofile');
                setUserData(response.data);
            } catch (error) {
                toast.error("Failed to fetch data");
            }
        };
        fetchLoggedUserData();
    }, []);

    // Récupérer la liste des facturations
    useEffect(() => {
        if (!UserData || !UserData.hospital_id || !UserData.role) return;

        const fetchBillings = async () => {
            try {
                const token = localStorage.getItem('access_token');
                if (!token) {
                    throw new Error('Token not found');
                }

                const response = await api.get('/clinic/allbilling');
                let billingsData = response.data;
                console.log('Billings Data:', billingsData);

                // Vérifier si UserData.hospital_id est un tableau ou un objet
                let hospitalIds = [];
                if (Array.isArray(UserData.hospital_id)) {
                    hospitalIds = UserData.hospital_id.map(hospital => hospital._id);
                } else {
                    hospitalIds = [UserData.hospital_id._id];
                }

                // Filtrer par hôpital
                billingsData = billingsData.filter(billing =>
                    hospitalIds.includes(billing.hospitalId)
                );

                // Filtrage par rôle
                if (UserData.role.name === 'medtinz_client_patient') {
                    const patientResponse = await api.get('/clinic/getPatientByUserId', {
                        headers: { Authorization: `Bearer ${token}` }
                    });

                    const patientId = patientResponse.data._id;
                    const filteredBillingsforpatient = billingsData.filter(billingData =>
                        billingData.patientId._id === patientId
                    );

                    setBillings(filteredBillingsforpatient);
                    setFilteredBillings(filteredBillingsforpatient);
                } else {
                    setBillings(billingsData);
                    setFilteredBillings(billingsData);
                }

                // Calculer le nombre total de pages
                setTotalPages(Math.ceil(billingsData.length / itemsPerPage));
            } catch (error) {
                console.error('Error fetching billings:', error);
                alert('Failed to fetch billings');
            }
        };

        fetchBillings();
    }, [UserData]);

    // Récupérer la liste des départements
    useEffect(() => {
        const fetchDepartments = async () => {
            try {
                const response = await api.get(`/api/departments`, {
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
                    }
                });
                setDepartments(response.data.data);
            } catch (error) {
                console.error('Erreur lors de la récupération des départements:', error);
            }
        };
        fetchDepartments();
    }, []);

    // Recherche locale
    // Remplacer handleSearchChange existante par celle-ci
    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        applyCombinedFilters(selectedServiceType, value);
    };

    // Mettre à jour la fonction handleDateFilterChange
    const handleDateFilterChange = () => {
        if (!startDate || !endDate) {
            alert('Please select both start and end dates');
            return;
        }
        applyCombinedFilters();
    };

    // Réinitialiser les filtres
    const resetFilter = () => {
        setStartDate('');
        setEndDate('');
        setSearchTerm('');
        setSelectedServiceType('');
        setFilteredBillings(billings);
        setCurrentPage(1);
    };

    // Nouvelle fonction pour appliquer tous les filtres ensemble
    const applyCombinedFilters = (serviceType = selectedServiceType, search = searchTerm, start = startDate, end = endDate) => {
        let filtered = [...billings];

        // Filtre par dates
        if (start && end) {
            const startDateObj = new Date(start);
            const endDateObj = new Date(end);
            startDateObj.setHours(0, 0, 0, 0);
            endDateObj.setHours(23, 59, 59, 999);

            filtered = filtered.filter(billing => {
                const billingDate = new Date(billing.createdAt);
                billingDate.setHours(0, 0, 0, 0);
                return billingDate >= startDateObj && billingDate <= endDateObj;
            });
        }

        // Filtre par type de service
        if (serviceType) {
            filtered = filtered.filter(billing =>
                billing.operationtype?.toLowerCase() === serviceType.toLowerCase()
            );
        }

        // Filtre par recherche
        if (search.trim()) {
            const lowercasedValue = search.toLowerCase();
            filtered = filtered.filter(billing => {
                const paymentIdMatch = billing.paymentuniqueId?.toLowerCase().includes(lowercasedValue);
                const operationTypeMatch = billing.operationtype?.toLowerCase().includes(lowercasedValue);
                const operationCodeMatch = billing.operationcode?.toLowerCase().includes(lowercasedValue);
                const patientNameMatch = billing.patientId &&
                    `${billing.patientId.firstname} ${billing.patientId.lastname}`.toLowerCase().includes(lowercasedValue);

                return paymentIdMatch || operationTypeMatch || operationCodeMatch || patientNameMatch;
            });
        }

        setFilteredBillings(filtered);
        setCurrentPage(1);
    };

    // Navigation entre les pages
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    // Calculer les billings à afficher sur la page courante
    useEffect(() => {
        const indexOfLastItem = currentPage * itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - itemsPerPage;
        const currentItems = filteredBillings.slice(indexOfFirstItem, indexOfLastItem);
        setDisplayedBillings(currentItems);

        // Mettre à jour le nombre total de pages
        setTotalPages(Math.ceil(filteredBillings.length / itemsPerPage));
    }, [currentPage, filteredBillings, itemsPerPage]);

    const handleinvoicepayment = async (billingID) => {
        navigate(`/Billings/invoiceAssurance/${billingID}`, {
            state: { billingID },
        });
    };

    return (
        <div className="dashboard-header">
            {/* <div className='row px-4'>
                <div className='col-lg-4 mb-3'>
                    <div className="pagetittle">
                        <h4 className='text-start'><b>Billing Management</b></h4>
                    </div>
                </div>
                <div className='col-lg-4'></div>
                <div className='col-lg-4 mx-auto'>
                    <div className="d-flex justify-content-end gap-4">
                        <div>
                            <img src={Adminprofil} className='cardicon' alt="Consultation Icon" width={'50'} height={'50'} />
                        </div>
                        <div>
                            <span className="ms-2" style={{ color: 'black' }} >{UserData.firstname} {UserData.lastname}</span>
                            <p className="ms-2" style={{ color: 'black' }} >{UserData.role?.name}</p>
                        </div>
                    </div>
                </div>
            </div> */}

            <div className="hosp-profile-header" style={{ backgroundColor: 'var(--hosp-background-color)', border: "none" }}>
                <div className="hosp-header__content">
                    {/* Titre à gauche */}
                    <div className="hosp-header__title">
                        <h4 className="hosp-page__title"><b>Billing Management</b></h4>
                    </div>

                    {/* Profil utilisateur à droite */}
                    <div className="hosp-user__profile">
                        {/* Indicateur de statut en ligne (optionnel) */}
                        <div className="hosp-status__indicator"></div>

                        <img src={UserData?.picture || Adminprofil} className='hosp-profile__image'  alt="Consultation Icon" />

                        <div className="hosp-user__details">
                            <span className="ms-2" style={{ color: 'black' }} >{UserData.firstname} {UserData.lastname}</span>
                            <p className="ms-2" style={{ color: 'black' }} >{UserData.role?.name}</p>
                        </div>
                    </div>
                </div>
            </div>



            <div className="Patientlist mt-4">
                <div className='tabsection'>
                    <CRow>
                        <CCol xs={12}>
                            <CCard className="card mb-4 p-4">
                                <CCardBody>
                                    <div className='tablist'>
                                        <div className='patientlistline'>
                                            <div className="search-container w-100">
                                                <div className="search-container w-80">
                                                    <div className="search-bar">
                                                        <FaSearch size="sm" className="search-icon" style={{ width: '20px', height: '20px' }} />
                                                        <input
                                                            className='ms-4 w-100'
                                                            type="text"
                                                            placeholder="Search for a patient, payment ID, or service"
                                                            value={searchTerm}
                                                            onChange={handleSearchChange}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='filter-barr mt-4'>
                                            <div>
                                                <input
                                                    type="date"
                                                    value={startDate}
                                                    onChange={(e) => setStartDate(e.target.value)}
                                                    className="form-control"
                                                    style={{ background: 'transparent', border: '1.4px solid #0056B3', color: '#0056B3' }}
                                                />
                                            </div>
                                            <div>
                                                <input
                                                    type="date"
                                                    value={endDate}
                                                    onChange={(e) => setEndDate(e.target.value)}
                                                    className="form-control"
                                                    style={{ background: 'transparent', border: '1.4px solid #0056B3', color: '#0056B3' }}
                                                />
                                            </div>
                                            <div>
                                                <button className="btn btn-outline-primary" onClick={handleDateFilterChange}>
                                                    <FaFilter /> Filter
                                                </button>
                                            </div>
                                            <div>
                                                <select
                                                    className="form-select"
                                                    style={{ background: 'transparent', border: '1.4px solid #0056B3', color: '#0056B3' }}
                                                    value={selectedServiceType}
                                                    onChange={(e) => {
                                                        setSelectedServiceType(e.target.value);
                                                        // Appliquer le filtre immédiatement
                                                        applyCombinedFilters(e.target.value, searchTerm, startDate, endDate);
                                                    }}
                                                >
                                                    <option value="">All Service Types</option>
                                                    <option value="Delete appointment">Delete appointment</option>
                                                    <option value="Update appointment">Update appointment</option>
                                                    <option value="Hospitalization payment">Hospitalization payment</option>
                                                    <option value="Appointment Consultation">Appointment Consultation</option>
                                                    <option value="Service offered">Service offered</option>
                                                </select>
                                            </div>
                                            <div>
                                                <button className="btn btn-outline-danger" onClick={resetFilter}>
                                                    <FaRedoAlt /> Reset Filters
                                                </button>
                                            </div>
                                        </div>

                                        <div className='patientlisttable'>
                                            <CTable className="mt-5 ctable-no-border text-center" align="middle" responsive>
                                                <CTableHead>
                                                    <CTableRow className='tablehead'>
                                                        <CTableHeaderCell scope="col">Payment ID</CTableHeaderCell>
                                                        <CTableHeaderCell scope="col">Service type</CTableHeaderCell>
                                                        <CTableHeaderCell scope="col">Service Code</CTableHeaderCell>
                                                        <CTableHeaderCell scope="col">Patient</CTableHeaderCell>
                                                        <CTableHeaderCell scope="col">Department</CTableHeaderCell>
                                                        <CTableHeaderCell scope="col">Amount</CTableHeaderCell>
                                                        <CTableHeaderCell scope="col">Amount Paid</CTableHeaderCell>
                                                        <CTableHeaderCell scope="col">Status</CTableHeaderCell>
                                                        <CTableHeaderCell scope="col">Action</CTableHeaderCell>
                                                    </CTableRow>
                                                </CTableHead>
                                                <CTableBody>
                                                    {displayedBillings.length > 0 ? (
                                                        displayedBillings.map((billing) => (
                                                            <CTableRow className="ctable-row" key={billing._id}>
                                                                <CTableDataCell>{billing.paymentuniqueId || 'N/A'}</CTableDataCell>
                                                                <CTableDataCell>{billing.operationtype || 'N/A'}</CTableDataCell>
                                                                <CTableDataCell>{billing.operationcode || 'N/A'}</CTableDataCell>
                                                                <CTableDataCell>
                                                                    {billing.patientId ? `${billing.patientId.firstname} ${billing.patientId.lastname}` : 'N/A'}
                                                                </CTableDataCell>
                                                                <CTableDataCell>
                                                                    {departments.find(dept => dept._id === billing.department)?.name || 'N/A'}
                                                                </CTableDataCell>
                                                                <CTableDataCell>
                                                                    {billing.amount || 'N/A'} {billing.currency || 'N/A'}
                                                                </CTableDataCell>
                                                                <CTableDataCell>
                                                                    {billing.montantpaye || 0} {billing.currency || 'N/A'}
                                                                </CTableDataCell>
                                                                <CTableDataCell>
                                                                    <span className={billing.paymentstatus ? 'coloredsucess' : 'coloredwarning'}>
                                                                        {billing.paymentstatus ? 'Paid' : 'Pending'}
                                                                    </span>
                                                                </CTableDataCell>
                                                                <CTableDataCell>
                                                                    <button
                                                                        className="btn btn-primary"
                                                                        style={{ borderRadius: '30px', padding: '5px 30px' }}
                                                                        onClick={() => handleShowModal(billing)}
                                                                    >
                                                                        View Details
                                                                    </button>
                                                                </CTableDataCell>
                                                            </CTableRow>
                                                        ))
                                                    ) : (
                                                        <CTableRow>
                                                            <CTableDataCell colSpan="9" className="text-center">
                                                                {loading ? 'Loading...' : 'No billings found'}
                                                            </CTableDataCell>
                                                        </CTableRow>
                                                    )}
                                                </CTableBody>
                                            </CTable>

                                            {/* Pagination */}
                                            {filteredBillings.length > 0 && (
                                                <div className="d-flex justify-content-center align-items-center mt-4">
                                                    <div>
                                                        <nav>
                                                            <ul className="pagination">
                                                                {/* Bouton Previous avec le symbole « */}
                                                                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                    <button className="page-link" onClick={() => handlePageChange(currentPage - 1)}>
                                                                        «
                                                                    </button>
                                                                </li>

                                                                {/* Logique d'affichage des numéros de page */}
                                                                {(() => {
                                                                    const pageNumbers = [];
                                                                    const totalVisible = 5; // Nombre total de boutons de page visibles

                                                                    // Toujours afficher la première page
                                                                    if (currentPage > 3) {
                                                                        pageNumbers.push(
                                                                            <li key={1} className="page-item">
                                                                                <button onClick={() => handlePageChange(1)} className="page-link">1</button>
                                                                            </li>
                                                                        );

                                                                        // Ajouter des ellipses si nécessaire
                                                                        if (currentPage > 4) {
                                                                            pageNumbers.push(
                                                                                <li key="ellipsis1" className="page-item disabled">
                                                                                    <span className="page-link">...</span>
                                                                                </li>
                                                                            );
                                                                        }
                                                                    }

                                                                    // Calculer la plage des pages à afficher autour de la page courante
                                                                    const startPage = Math.max(1, currentPage - Math.floor((totalVisible - 3) / 2));
                                                                    const endPage = Math.min(totalPages, startPage + (totalVisible - 3));

                                                                    // Générer les boutons de page pour la plage calculée
                                                                    for (let i = startPage; i <= endPage; i++) {
                                                                        pageNumbers.push(
                                                                            <li key={i} className={`page-item ${currentPage === i ? 'active' : ''}`}>
                                                                                <button onClick={() => handlePageChange(i)} className="page-link">{i}</button>
                                                                            </li>
                                                                        );
                                                                    }

                                                                    // Ajouter des ellipses et la dernière page si nécessaire
                                                                    if (currentPage < totalPages - 2) {
                                                                        if (currentPage < totalPages - 3) {
                                                                            pageNumbers.push(
                                                                                <li key="ellipsis2" className="page-item disabled">
                                                                                    <span className="page-link">...</span>
                                                                                </li>
                                                                            );
                                                                        }

                                                                        pageNumbers.push(
                                                                            <li key={totalPages} className="page-item">
                                                                                <button onClick={() => handlePageChange(totalPages)} className="page-link">{totalPages}</button>
                                                                            </li>
                                                                        );
                                                                    }

                                                                    return pageNumbers;
                                                                })()}

                                                                {/* Bouton Next avec le symbole » */}
                                                                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                                    <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}>
                                                                        »
                                                                    </button>
                                                                </li>
                                                            </ul>
                                                        </nav>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </CCardBody>
                            </CCard>
                        </CCol>
                    </CRow>
                </div>
            </div>

            {/* Modal pour afficher les détails du billing */}
            <CModal visible={showModal} onClose={handleCloseModal} size='lg'>
                <CModalHeader>
                    <CModalTitle>Billing Details</CModalTitle>
                </CModalHeader>
                <CModalBody>
                    {selectedBilling ? (
                        <div>
                            <p><strong>Payment ID:</strong> {selectedBilling.paymentuniqueId}</p>
                            <p><strong>Service Type:</strong> {selectedBilling.operationtype}</p>
                            <p><strong>Service Code:</strong> {selectedBilling.operationcode}</p>
                            <p><strong>Department:</strong> {departments.find(department => department._id === selectedBilling.department)?.name}</p>
                            <p><strong>Amount:</strong> {selectedBilling.amount} {selectedBilling.currency}</p>
                        </div>
                    ) : (
                        <p>Loading...</p>
                    )}
                </CModalBody>
                <CModalFooter>
                    <CButton color="secondary" onClick={handleCloseModal}>Close</CButton>
                    <button
                        className="btn btn-primary"
                        style={{ borderRadius: '30px', padding: '10px 20px' }}
                        onClick={() => handleinvoicepayment(selectedBilling._id)}
                        disabled={selectedBilling.paymentstatus}>
                        <FaFileInvoiceDollar /> Make Payment
                    </button>
                </CModalFooter>
            </CModal>
        </div>
    );
}

export default PaymentList;